<template>
  <div
    class="td-value"
    :class="{'grey--text': muted }"
    :data-qa="`compare-cell-${field.value}`">
    <template v-if="!tender.biddingType.tenderingForPercentage && field.value == 'price'">
      <sTooltip
        v-if="item.bestPrice"
        :content="$t('Tenders.BidPriceTooltipText')"
        content-class="price-tooltip"
        top>
        <div
          class="currency_badge">
          {{ formatPrice(item.currencyPrice) }} {{ item.currencyTitle }}
        </div>
      </sTooltip>
      <span
        v-else-if="item.currencyPrice"
        data-qa="currencyPrice-value">
        {{ formatPrice(item.currencyPrice) }} {{ item.currencyTitle }}
      </span>
      <span v-else> – </span>
      <CurrencyConversionTooltip
        v-if="item.price"
        class="mt-2"
        :currency="item.currencyTitle || '-'"
        :current-id="item.currencyId"
        :nbu-currency="item.currency"
        :price="item.currencyPrice"/>
    </template>
    <template v-else-if="field.value == 'summ'">
      <span
        v-if="item.currencySumm || item.summ"
        data-qa="summ-value">{{ formatPrice(item.currencySumm || item.summ) }} {{ tenderCurrencyTitle }}</span>
      <span
        v-else
        data-qa="summ-value">-</span>
      <CurrencyConversionTooltip
        v-if="item.price"
        :currency="item.currencyTitle || '-'"
        :current-id="item.currencyId"
        :nbu-currency="item.currency"
        :price="item.currencySumm || item.summ"/>
    </template>
    <template v-else-if="field.value == 'reducedPrice'">
      <span
        v-if="item.reducedPrice"
        data-qa="reducedPrice-value">{{ formatPrice(item.reducedPrice) }} {{ tenderCurrencyTitle }}</span>
      <span
        v-else
        data-qa="reducedPrice-value">-</span>
      <CurrencyConversionTooltip
        v-if="item.price"
        :currency="item.currencyTitle || '-'"
        :current-id="item.currencyId"
        :nbu-currency="item.currency"
        :price="item.reducedPrice"/>
    </template>
    <template v-else-if="tender.biddingType.tenderingForPercentage && field.value == 'price'">
      <span
        v-if="item.price"
        data-qa="price-value">{{ $n(item.price, 'decimal') }} %</span>
      <span
        v-else
        data-qa="price-value">-</span>
    </template>
    <span
      v-else-if="field.value != 'timeSupplyBids' && field.value != 'criteria'"
      class="mr-1"
      data-qa="lot-value">
      {{ item[field.value] }}
    </span>
    <!--  after value / different view -->
    <!-- агрегований рядок лоту (view=lotGroups) не має поля criteria — критерій беремо з all_criteria -->
    <template v-if="item[field.value] || (growthBook?.compareLotGroupsCriteria && field.value == 'criteria')">
      <span
        v-if="field.value == 'quantity'"
        data-qa="quantity-value">
        {{ item.unit ? item.unit.title : ' –' }}
      </span>
      <span
        v-else-if="field.value == 'timeSupplyBids'"
        data-qa="timeSupplyBids-value">
        {{ formatBy(item.timeSupplyBids, 'DD.MM.YYYY, HH:mm') || ' –' }}
      </span>
      <div
        v-else-if="field.value == 'criteria' && criteria"
        class="mr-1"
        data-qa="criteria-value">
        <span>
          {{ (normalizeNum(criteria.value) ? formSum (normalizeNum(criteria.value)) : criteria.value ) }}
        </span>
        <span v-if="criteria.score !== null ">
          : {{ (normalizeNum(criteria.score) ? formSum (normalizeNum(criteria.score)) : criteria.score ) }}
        </span>
      </div>
    </template>
  </div>
</template>
<script>
import CurrencyConversionTooltip from 'components/common/elements/CurrencyConversionTooltip.vue'

import { modalMixin } from 'mixins'

/**
 * Значення однієї клітинки порівняльної таблиці: ціна (з кращою ціною / відсотком), сума,
 * кількість з одиницею, дата подачі, критерій або довільне поле item[field.value]
 */
export default {
  name: 'ComparativeTableCell',
  mixins: [ modalMixin ],
  computed: {
    tenderCurrencyTitle() {
      return this.tender.currency ? this.tender.currency.title : '–'
    },
    criteria() {
      if (this.field.value !== 'criteria') {
        return null
      }
      let res
      // група 'default' (стандартні умови) має items-об'єкт, а не масив критеріїв
      this.item.all_criteria?.find(it => Array.isArray(it.items) && (res = it.items.find(el => el.title == this.field.text)))
      return res
    },
  },
  methods: {
    /**
     * Грошове значення: за прапорцем `comparePriceRoundingDigit` — правило сторінки тендера,
     * інакше завжди 2 знаки
     */
    formatPrice(value) {
      return this.growthBook?.comparePriceRoundingDigit ? this.$formatBidPrice(value) : this.$n(value, 'decimal')
    },
  },
  components: {
    CurrencyConversionTooltip
  },
  props: {
    /** пропозиція (позиція) або підсумок по лоту з тими самими полями */
    item: {
      type: Object,
      required: true
    },
    /** рядок таблиці { text, value } */
    field: {
      type: Object,
      required: true
    },
    tender: {
      type: Object,
      required: true
    },
    /** значення однакове в усіх колонках — показується сірим */
    muted: {
      type: Boolean,
      default: false
    },
  },
}
</script>
<style lang="scss" scoped>
.currency_badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: bold;
  color: #000000;
  background-color: var(--color-success);
}
</style>
